// extracted by mini-css-extract-plugin
export default {"App":"DownloadOwner_App__HLpP7","container":"DownloadOwner_container__WwBmZ","containerCard":"DownloadOwner_containerCard__wjhlh","messageUser":"DownloadOwner_messageUser__wjroi"};